import { FMDocumentTileSubscriptionType } from "@/graphql";

export function getFilesInFilter(
  files: { id?: number; fileId?: number; createdAt: string; createdAtISO: string }[],
  filterType: FMDocumentTileSubscriptionType,
  filesShownCount: number,
  fileIds: number[],
) {
  switch (filterType) {
    case FMDocumentTileSubscriptionType.CUSTOM:
      return files.filter((file) => fileIds.includes(file.id ?? file.fileId ?? -1));
    case FMDocumentTileSubscriptionType.LAST_CHANGED:
      return files
        .toSorted(
          (a, b) =>
            new Date(b.createdAtISO ?? b.createdAt).valueOf() -
            new Date(a.createdAtISO ?? a.createdAt).valueOf(),
        )
        .slice(0, filesShownCount);
    case FMDocumentTileSubscriptionType.RECENTLY_CHANGED:
      return files.filter(
        (file) =>
          new Date().valueOf() - new Date(file.createdAtISO ?? file.createdAt).valueOf() <
          1000 * 60 * 60 * 24 * filesShownCount,
      ); // last filesShownCount days
    case FMDocumentTileSubscriptionType.ALL:
    default:
      return files;
  }
}

export function getTranslationStringForSubscriptionType(
  type: FMDocumentTileSubscriptionType,
  filesShownCount: number,
) {
  switch (type) {
    case FMDocumentTileSubscriptionType.CUSTOM:
      return "modules.filemanagement.components.FMDocumentTile.FMDocumentSubscriptionComponent.custom";
    case FMDocumentTileSubscriptionType.LAST_CHANGED:
      if (filesShownCount === 1) {
        return "modules.filemanagement.components.FMDocumentTile.FMDocumentSubscriptionComponent.lastChanged1";
      }
      if (filesShownCount === 3) {
        return "modules.filemanagement.components.FMDocumentTile.FMDocumentSubscriptionComponent.onlyInSubfolders";
      }
      return "global.na";
    case FMDocumentTileSubscriptionType.RECENTLY_CHANGED:
      if (filesShownCount === 30) {
        return "modules.filemanagement.components.FMDocumentTile.FMDocumentSubscriptionComponent.recentlyChanged30";
      }
      return "global.na";
    case FMDocumentTileSubscriptionType.ALL:
    default:
      return "modules.filemanagement.components.FMDocumentTile.FMDocumentSubscriptionComponent.all";
  }
}

export type SubscriptionEditSettings = {
  id?: number;
  type: FMDocumentTileSubscriptionType;
  filesShownCount: number;
  folderId: number;
  fileIds: number[];
};

export function getOrderedDocumentTileFileIds(
  connections: { fileId: number; sortOrder: number }[],
) {
  return connections.toSorted((a, b) => a.sortOrder - b.sortOrder).map(({ fileId }) => fileId);
}
